<template>
    <div class="web" v-loading="loading">
        <el-row :gutter="20">

            <!-- 简历目录 -->
            <el-col :span="4">
                <div class="catalogue" :class="isFixed?'isFixed':''">
                    <div class="catalogueTitle">简历目录</div>
                    <div class="catalogueBox" v-for="(item, index) in catalogueList" :key="index" @click="changeTab(item.active)">{{item.name}}</div>
                </div>
            </el-col>

            <!-- 简历 -->
            <el-col :span="isFixed?19:15">
                <div class="resume" :class="isFixed?'isFixed':''">
                    <div class="resumeTitle clearfix">
                        <div class="fl">我的在线简历</div>
                        <el-button v-if="!edit_resume" @click="editResume" icon="el-icon-edit" type="text" class="fr" style="padding: 0;line-height: 52px;">编辑</el-button>
                    </div>

                    <!-- 预览简历 -->
                    <div v-if="!edit_resume" class="noData">
                        <div class="preview">
                            <div class="previewName" id="gerenxinxi">{{editForm.vita_name}}</div>
                            <div class="personalInfo">
                                <div>
                                    <span><i class="el-icon-suitcase"></i>{{editForm.worktime}}</span>
                                    <el-divider direction="vertical"></el-divider>
                                    <span><i class="el-icon-school"></i>{{editForm.education}}</span>
                                    <el-divider direction="vertical"></el-divider>
                                    <span v-if="editForm.members_state"><i class="el-icon-user"></i>{{memberList[editForm.members_state].name}}</span>
                                    <span v-if="!editForm.members_state"><i class="el-icon-user"></i>离职-立即上岗</span>
                                </div>
                                <div>
                                    <span><i class="el-icon-date"></i>{{editForm.birthyear}}</span>
                                    <el-divider direction="vertical"></el-divider>
                                    <span><i class="el-icon-mobile-phone"></i>{{editForm.mobile}}</span>
                                </div>
                                <div class="certificate">
                                    <div>证书</div>
                                    <div class="certificateBox">
                                        <el-tag v-for="(item, index) in editForm.job_confim" :key="index">{{item}}</el-tag>
                                    </div>
                                </div>
                                <div class="certificate">
                                    <div>个人标签</div>
                                    <div class="certificateBox">
                                        <el-tag v-for="(item, index) in editForm.selftags" :key="index">{{item}}</el-tag>
                                    </div>
                                </div>
                            </div>
                            <div class="personalInfo">
                                <div class="resumeBoxTitle" id="qiuzhiqiwang">求职期望</div>
                                <div>
                                    <span><i class="el-icon-collection"></i>{{editForm.desired_position}}</span>
                                    <el-divider direction="vertical"></el-divider>
                                    <span><i class="el-icon-money"></i>{{editForm.ideamoney}}{{editForm.ideamoney === '面议'?'':'元/月'}}</span>
                                    <el-divider direction="vertical"></el-divider>
                                    <span><i class="el-icon-location-outline"></i>{{editForm.province_name?editForm.province_name:''}}{{editForm.city_name?editForm.city_name:''}}{{editForm.dist_name?editForm.dist_name:''}}</span>
                                </div>
                            </div>
                            <div class="personalInfo">
                                <div class="resumeBoxTitle" id="ziwomiaoshu">自我描述</div>
                                <div v-html="editForm.workhistory" v-if="editForm.workhistory">{{editForm.workhistory}}</div>
                                <div v-else class="notext">暂无描述</div>
                            </div>
                            <div class="personalInfo">
                                <div class="resumeBoxTitle" id="jiaoyujingli">教育经历</div>
                                <div class="previewEdu" v-if="editForm.education_experience !== undefined && editForm.education_experience.length > 0">
                                    <div v-for="(item, index) in editForm.education_experience" :key="index">
                                        <div class="schoolName">
                                            <span>{{item.schoolName}}</span>
                                            <span>{{item.beginTime}}-{{item.endTime}}</span>
                                        </div>
                                        <div class="major">
                                            <span>{{item.major}}</span>
                                            <el-divider direction="vertical"></el-divider>
                                            <span>{{item.education}}</span>
                                        </div>
                                        <el-divider v-if="index +1 !== editForm.education_experience.length"></el-divider>
                                    </div>
                                </div>
                                <div v-else class="notext">暂无教育经历</div>
                            </div>
                            <div class="personalInfo">
                                <div class="resumeBoxTitle" id="gongzuojingli">工作经历</div>
                                <div class="previewEdu" v-if="editForm.work_experience !== undefined && editForm.work_experience.length > 0">
                                    <div v-for="(item, index) in editForm.work_experience" :key="index">
                                        <div class="schoolName">
                                            <span class="major">{{item.unitName}}</span>
                                            <span>{{item.beginTime}}-{{item.endTime?item.endTime:'至今'}}</span>
                                        </div>
                                        <div class="major">职位名称：<span>{{item.jobName}}</span></div>
                                        <div class="major" v-if="item.description">工作内容描述：<div v-html="item.description">{{item.description}}</div></div>
                                        <el-divider v-if="index +1 !== editForm.work_experience.length"></el-divider>
                                    </div>
                                </div>
                                <div v-else class="notext">暂无工作经历</div>
                            </div>
                        </div>
                    </div>

                    <!-- 编辑简历 -->
                    <div class="resumeEdit" v-if="edit_resume">
                        <el-form ref="form" :model="editForm" :rules="rule">
                            <el-form-item>
                                <div style="color: #606266;">头像</div>
                                <el-upload
                                    action= ''
                                    :file-list="editForm.avatar"
                                    list-type="picture-card"
                                    :http-request="BusinessFun"
                                    :on-remove="handleRemove"
                                >
                                <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <div class="resumeBoxTitle" id="gerenxinxi">个人信息</div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="姓名" class="boxHei" prop="vita_name">
                                        <div><el-input v-model="editForm.vita_name" placeholder="请输入姓名"></el-input></div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="当前求职状态" class="boxHei">
                                        <div>
                                            <el-select class="boxWid" v-model="editForm.members_state" placeholder="请选择求职状态">
                                                <el-option
                                                    v-for="(item, index) in memberList"
                                                    :key="index"
                                                    :label="item.name"
                                                    :value="item.active">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="性别" class="boxHei" prop="sex">
                                        <div>
                                            <el-radio-group v-model="editForm.sex" class="boxWid">
                                                <el-radio-button label="男"></el-radio-button>
                                                <el-radio-button label="女"></el-radio-button>
                                            </el-radio-group>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="出生年份" class="boxHei" prop="birthyear">
                                        <div>
                                            <el-date-picker
                                                class="boxWid"
                                                v-model="editForm.birthyear"
                                                type="year"
                                                value-format="yyyy"
                                                placeholder="选择年份">
                                            </el-date-picker>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="手机" class="boxHei" prop="mobile">
                                        <div v-if="!editForm.vid"><el-input v-model.number="editForm.mobile" placeholder="请输入手机"></el-input></div>
                                        <div v-else>
                                            <div>{{editForm.mobile}}</div>
                                            <div class="editTips">请去小程序上修改手机</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="学历" class="boxHei" prop="education">
                                        <div>
                                            <el-select class="boxWid" v-model="editForm.education" placeholder="请选择学历">
                                                <el-option
                                                    v-for="(item, index) in eduList"
                                                    :key="index"
                                                    :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="证书" class="boxHei">
                                        <div>
                                            <el-select multiple filterable allow-create default-first-option class="boxWid" v-model="editForm.job_confim" placeholder="请选择证书或者输入，回车添加自定义">
                                                <el-option
                                                    v-for="(item, index) in job_confimList"
                                                    :key="index"
                                                    :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="工作经验" class="boxHei">
                                        <div>
                                            <el-select class="boxWid" v-model="editForm.worktime" placeholder="请选择工作经验">
                                                <el-option
                                                    v-for="(item, index) in worktimeList"
                                                    :key="index"
                                                    :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="个人标签" class="boxHei">
                                        <div>
                                            <el-select multiple filterable allow-create default-first-option class="boxWid" v-model="editForm.selftags" placeholder="请选择标签或者输入，回车添加自定义">
                                                <el-option
                                                    v-for="(item, index) in selftagsList"
                                                    :key="index"
                                                    :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div class="resumeBoxTitle" id="qiuzhiqiwang">求职期望</div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="意向职位" class="boxHei">
                                        <div>
                                            <el-select class="boxWid" v-model="editForm.desired_position" placeholder="请选择意向职位">
                                                <el-option
                                                    v-for="(item, index) in postList"
                                                    :key="index"
                                                    :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="工作区域" class="boxHei">
                                        <div>
                                            <el-cascader
                                                class="boxWid"
                                                v-model="editForm.areaAll"
                                                :props="{value: 'region_id',label: 'region_name'}"
                                                placeholder= "请选择工作区域"
                                                :options="areaList"
                                                ref="editCascader"
                                                @change="areaChange">
                                            </el-cascader>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="期望薪资" class="boxHei">
                                        <div>
                                            <br />
                                            <el-row :gutter="10">
                                                <el-col :span="10">
                                                    <el-select v-model="editForm.moneyMin" placeholder="请选择薪资" @change="moneyChange">
                                                        <el-option
                                                            v-for="(item,index) in moneyMinList"
                                                            :key="index"
                                                            :label="item"
                                                            :value="item">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                                <el-col v-if="editForm.ideamoney != '面议'" :span="4" style="text-align: center;">至</el-col>
                                                <el-col :span="10" v-if="editForm.ideamoney != '面议'">
                                                    <el-select v-model="editForm.moneyMax" placeholder="请选择薪资" @change="moneyMaxChange">
                                                        <el-option
                                                            v-for="(item,index) in moneyMaxList"
                                                            :key="index"
                                                            :label="item"
                                                            :value="item">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div class="resumeBoxTitle" id="ziwomiaoshu">自我描述</div>
                            <el-row :gutter="10">
                                <el-col :span="24">
                                    <el-form-item>
                                        <div>
                                            <el-input
                                                type="textarea"
                                                :autosize="{ minRows: 5}"
                                                placeholder="请输入自我描述"
                                                v-model="editForm.workhistory">
                                            </el-input>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div class="resumeBoxTitle clearfix" id="jiaoyujingli">教育经历
                                <el-button class="fr" type="text" icon="el-icon-circle-plus-outline" style="padding: 0;" @click="addBox(editForm.education_experience,'1')">添加</el-button>
                            </div>
                            <div>
                                <div v-for="(item, index) in editForm.education_experience" :key="index" class="box">
                                    <el-button type="text" icon="el-icon-delete" class="delBox" @click="delBox(editForm.education_experience, index)" v-if="editForm.education_experience.length > 1">删除</el-button>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="学校名称" class="boxHei">
                                                <div>
                                                    <el-input
                                                        placeholder="请输入学校名称"
                                                        v-model="item.schoolName">
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="所学专业" class="boxHei">
                                                <div>
                                                    <el-input
                                                        placeholder="请输入所学专业"
                                                        v-model="item.major">
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="入学时间" class="boxHei">
                                                <div>
                                                    <el-date-picker
                                                        class="boxWid"
                                                        v-model="item.beginTime"
                                                        type="month"
                                                        value-format="yyyy-MM"
                                                        placeholder="请选择入学时间">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="毕业时间" class="boxHei">
                                                <div>
                                                    <el-date-picker
                                                        class="boxWid"
                                                        v-model="item.endTime"
                                                        type="month"
                                                        value-format="yyyy-MM"
                                                        placeholder="请选择毕业时间">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="学历" class="boxHei">
                                                <div>
                                                    <el-select class="boxWid" v-model="item.education" placeholder="请选择学历">
                                                        <el-option
                                                            v-for="(item,indexs) in eduList"
                                                            :key="indexs"
                                                            :label="item"
                                                            :value="item">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-divider v-if="index +1 !== editForm.education_experience.length"></el-divider>
                                </div>
                            </div>
                            <div class="resumeBoxTitle clearfix" id="gongzuojingli">工作经历
                                <el-button class="fr" type="text" icon="el-icon-circle-plus-outline" style="padding: 0;" @click="addBox(editForm.work_experience,'2')">添加</el-button>
                            </div>
                            <div>
                                <div v-for="(item, index) in editForm.work_experience" :key="index" class="box">
                                    <el-button type="text" icon="el-icon-delete" class="delBox" @click="delBox(editForm.work_experience, index)" v-if="editForm.work_experience.length > 1">删除</el-button>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="单位名称" class="boxHei">
                                                <div>
                                                    <el-input
                                                        placeholder="请输入单位名称"
                                                        v-model="item.unitName">
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="职位名称" class="boxHei">
                                                <div>
                                                    <el-input
                                                        placeholder="请输入职位名称"
                                                        v-model="item.jobName">
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="入职时间" class="boxHei">
                                                <div>
                                                    <el-date-picker
                                                        class="boxWid"
                                                        v-model="item.beginTime"
                                                        type="month"
                                                        value-format="yyyy-MM"
                                                        placeholder="请选择入职时间">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="离职时间" class="boxHei">
                                                <div>
                                                    <el-date-picker
                                                        class="boxWid"
                                                        v-model="item.endTime"
                                                        type="month"
                                                        value-format="yyyy-MM"
                                                        placeholder="不选择离职时间为至今">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="工作内容描述">
                                                <div>
                                                    <el-input
                                                        type="textarea"
                                                        :autosize="{ minRows: 5}"
                                                        placeholder="请输入工作内容描述"
                                                        v-model="item.description">
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-divider v-if="index +1 !== editForm.work_experience.length"></el-divider>
                                </div>
                            </div>
                        </el-form>

                        <!-- 提交简历 -->
                        <div class="submitResume">
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <div class="submitResumeBtn submitResumeBtnNo" @click="resetResume">取消</div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="submitResumeBtn submitResumeBtnYes" @click="submitResume">提交</div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </el-col>

            <!-- 操作 -->
            <el-col :span="5">
                <div class="enclosureTip">上传附件简历，投递简历，快人一步</div>
                <div class="enclosure">
                    <div class="enclosureTitle">附件管理</div>
                    <div class="enclosureBox clearfix" v-if="editForm.attachName">
                        <el-tooltip class="item" effect="dark" :content="editForm.attachName" placement="left-start">
                            <div class="attach textOverflow fl" @click="openAttach"><i class="el-icon-document"></i>{{editForm.attachName}}</div>
                        </el-tooltip>
                        <div class="enclosureDel fr">
                            <i class="el-icon-delete" @click="enclosureDel"></i>
                        </div>
                    </div>
                    <div class="enclosureBtn" @click="openUpload">上传附件简历</div>
                </div>

                <!-- 隐私设置 -->
                <div class="Privacy">
                    <div class="PrivacyBox">
                        <div class="clearfix">
                            <div class="fl">隐私设置</div>
                            <div class="fr">
                                <el-link type="primary" @click="setUp">设置</el-link>
                            </div>
                        </div>
                    </div>
                    <div class="PrivacyBox">
                        <div class="clearfix">
                            <div class="fl">屏蔽园所</div>
                            <div class="fr">已屏蔽<span class="PrivacyBtn">{{shieldList.length}}</span>所</div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <!-- 上传 -->
        <upload :uploadDialog="uploadDialog" @closeUpload="closeUpload" @uploadSuccess="uploadSuccess" />
    </div>
</template>

<script>
    import noData from '@/components/noData'
    import region from "@/js/publicJson"
    import upload from '@/components/upload'
    export default {
        components: {
            noData,
            upload
        },
        data() {
            return {
                loading: true,
                rule: {
                    vita_name: [
                        { required: true, message: '请输入您的姓名', trigger: 'blur' },
                        { min: 3, max: 10, message: '姓名最少两个字，最多十个字', trigger: 'blur' }
                    ],
                    sex: [
                        { required: true, message: '请选择您的性别', trigger: 'change' }
                    ],
                    birthyear: [
                        { required: true, message: '请选择出生年份', trigger: 'change' }
                    ],
                    mobile: [
                        { required: true, message: '请输入您的手机', trigger: 'blur' },
                        { type: 'number', message: '请输入正确的手机号'}
                    ],
                    education: [
                        { required: true, message: '请选择您的学历', trigger: 'change' }
                    ]
                },
                uploadDialog: false, // 上传
                catalogueList: [{
                    active: 'gerenxinxi',
                    name: '个人信息'
                }, {
                    active: 'qiuzhiqiwang',
                    name: '求职期望'
                }, {
                    active: 'ziwomiaoshu',
                    name: '自我描述'
                }, {
                    active: 'jiaoyujingli',
                    name: '教育经历'
                }, {
                    active: 'gongzuojingli',
                    name: '工作经历'
                }],
                resume: {},
                noResume: true,
                edit_resume: false,
                editForm: {},

                // 求职状态
                memberList: [{
                    name: '离职-立即上岗',
                    active: 0
                }, {
                    name: '在职-月内上岗',
                    active: 1
                }, {
                    name: '在职-考虑机会',
                    active: 2
                }, {
                    name: '在职-暂不考虑',
                    active: 3
                }],

                // 学历
                eduList: ['初中','高中','中专','大专','本科','本科以上'],

                // 证书
                job_confimList: ['保育员证','教师资格证','园长证','育婴师证','保健医证','医师资格证'],

                // 工作经验
                worktimeList: ['无经验','1年以内','1-2年','2-4年','4-6年','6-10年','10年以上'],

                // 个人标签
                selftagsList: ['唱歌','跳舞','绘画','弹琴','讲故事','懂英语','形象好','亲和力','高学历','普通话','口才好','懂管理','手艺活','有创意'],

                // 意向职位
                postList: ["主班老师","乐高老师","书法老师","亲子老师","体育老师","作文老师","保健医生","保安","保教主任","保洁","保育员","其他职位","创客老师","副园长","副班老师","厨师","司机","后勤主任","园长","园长助理","外教老师","实习生","家庭教育老师","幼教老师","感统老师","托育老师","拼音老师","教学主任","数学老师","早教老师","校长","测评师","生活老师","编程老师","美术老师","舞蹈老师","英语老师","蒙氏老师","行政老师","课程营销","课程顾问","速算导师","钢琴老师","音乐老师"],

                // 工作区域
                areaList: region.region,

                // 最小工资
                moneyMinList: ['面议', 500, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000, 16000, 17000, 18000, 19000, 20000, 21000, 22000, 23000, 24000, 25000, 26000, 27000, 28000, 29000, 30000],
                moneyMaxList: [],
                isFixed: false,

                // 屏蔽园所
                shieldList: []
            }
        },
        mounted() {
            this.getResume()
            this.getShield()
            window.addEventListener('scroll', this.handleScroll, true)

        },
        methods: {

            // 上传头像
            BusinessFun(f) {
                let obj = {
                    file: f.file
                }
                this.api.uploadf('/5ce7e4f35dc2b',obj).then(r=>{
                    this.editForm.avatar = []
                    this.editForm.avatar.push({
                        id: 0,
                        url: r.data.fileUrl
                    })
                })
            },

            // 删除头像
            handleRemove(f) {
                this.editForm.avatar = []
            },

            // 获取屏蔽园所
            getShield() {
                this.api.get('/5d8c7a434b58e', {}).then(r=> {
                    this.shieldList = r.data.list
                })
            },

            // 设置
            setUp() {
                this.$router.push({path: '/job/accountNumber', query: {tabActive: '3'}})
            },

            // 关闭上传
            closeUpload(uploadDialog) {
                this.uploadDialog = uploadDialog
            },

            // 上传
            openUpload() {
                this.uploadDialog = true
            },

            // 滚动条滚动改变布局
            handleScroll() {
                // console.log('滚动高度', window.pageYOffset)
                if(window.pageYOffset >= 70) {
                    this.isFixed = true
                } else {
                    this.isFixed = false
                }
            },

            // 获取简历
            getResume() {
                this.loading = true
                this.api.get('/5cf3c3436edc5', {}).then(r=>{
                    this.loading = false
                    if(r.data.list.length === 0) {
                        this.editForm = {
                            sex: '女',
                            education_experience: [{
                                schoolName: '',
                                beginTime: '',
                                endTime: '',
                                major: '',
                                education: ''
                            }],
                            work_experience: [{
                                unitName: '',
                                beginTime: '',
                                endTime: '',
                                jobName: '',
                                description: ''
                            }]
                        }
                        this.edit_resume = true
                        this.noResume = true
                    } else {
                        this.api.get('/5cf3c3dd5d8d3', { vid: r.data.list[0].vid }).then(r=>{
                            this.editForm = r.data
                            if(!this.editForm.avatar ) {
                                this.editForm.avatar = []
                            } else {
                            this.editForm.avatar = [{
                                url: this.editForm.avatar
                            }]
                            }
                            if(this.editForm.attach) {
                                this.editForm.attachName = this.editForm.attach.split('/')[this.editForm.attach.split('/').length - 1]
                                this.editForm.attachName = decodeURI(this.editForm.attachName).split('_')[0]
                            }
                            if(!this.editForm.education_experience) {
                                this.editForm.education_experience = "[]"
                            }
                            if(!this.editForm.work_experience) {
                                this.editForm.work_experience = "[]"
                            }
                            JSON.stringify(this.editForm) === "{}"?this.noResume = true:this.noResume = false
                            if(this.editForm.education_experience) {
                                this.editForm.education_experience = JSON.parse(this.editForm.education_experience)
                            } else {
                                
                            }
                            if(this.editForm.mobile) {
                                this.editForm.mobile = Number(this.editForm.mobile)
                            }
                            if(this.editForm.job_confim) {
                                this.editForm.job_confim = JSON.parse(this.editForm.job_confim)
                            }
                            if(this.editForm.selftags) {
                                this.editForm.selftags = JSON.parse(this.editForm.selftags)
                            }
                            if(this.editForm.work_experience) {
                                this.editForm.work_experience = JSON.parse(this.editForm.work_experience)
                                this.editForm.work_experience.forEach(o=>{
                                    o.description = o.description.replace(/↵/g, "<br>");
                                    o.description = o.description.replace(/\n/g, "<br>");
                                })
                            }
                            if(this.editForm.ideamoney_min) {
                                this.editForm.moneyMin = this.editForm.ideamoney_min
                            }
                            if(this.editForm.ideamoney_max) {
                                this.editForm.moneyMax = this.editForm.ideamoney_max
                            }
                            if(this.editForm.workhistory) {
                                this.editForm.workhistory = this.editForm.workhistory.replace(/↵/g, "<br>");
                                this.editForm.workhistory = this.editForm.workhistory.replace(/\n/g, "<br>");
                            }
                            this.editForm.areaAll = [this.editForm.province, this.editForm.city, this.editForm.dist]
                        })
                    }
                })
            },

            // 区域选择
            areaChange(e) {
                let pathLabels = this.$refs.editCascader.getCheckedNodes()[0].pathLabels
                this.editForm.province_name = pathLabels[0]
                this.editForm.city_name = pathLabels[1]
                this.editForm.dist_name = pathLabels[2]

                this.editForm.province = e[0]
                this.editForm.city = e[1]
                this.editForm.dist = e[2]
            },

            // 薪资选择
            moneyChange(e) {
                console.log(0)
                if(e === '面议') {
                    this.editForm.ideamoney = '面议'
                } else {
                    let j = e+500
                    while(j < e + 500 * 29){
                        this.moneyMaxList.push(j);
                        j+=500
                    }
                    this.editForm.ideamoney = e + '-' + e + 500
                }
            },

            // 薪资提交改变
            moneyMaxChange(e) {
                this.editForm.ideamoney = this.editForm.moneyMin + '-' + e
            },

            // 添加
            addBox(data,type) {
                switch (type) {
                    case '1':
                        data.push({
                            schoolName: '',
                            major: '学前教育',
                            beginTime: '',
                            endTime: '',
                            education: ''
                        })
                    break;

                    case '2':
                        data.push({
                            unitName: '',
                            jobName: '',
                            beginTime: '',
                            endTime: '',
                            description: ''
                        })
                    break;
                }
            },

            // 删除
            delBox(data, i) {
                data.splice(i ,1)
            },

            // 点击简历目录页面滚动
            changeTab(acitve) {
                document.getElementById(acitve).scrollIntoView({
                    block: 'start',
                    behavior: 'smooth' // 代表平滑滚动
                });
            },

            // 删除附件简历
            enclosureDel() {
                this.editForm.attach = ''
                if(this.editForm.work_experience.length > 0) {
                    this.editForm.work_experience = JSON.stringify(this.editForm.work_experience)
                }
                if(this.editForm.education_experience.length > 0) {
                    this.editForm.education_experience = JSON.stringify(this.editForm.education_experience)
                }
                this.api.post('/5cf3c448ad3db', this.editForm).then(r =>{
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    this.edit_resume = false
                    this.getResume()
                })
            },

            // 编辑简历
            editResume() {
                this.edit_resume = true
            },

            // 提交简历
            submitResume() {
                this.loading = true
                if(this.editForm.work_experience.length > 0) {
                    this.editForm.work_experience = JSON.stringify(this.editForm.work_experience)
                }
                if(this.editForm.education_experience.length > 0) {
                    this.editForm.education_experience = JSON.stringify(this.editForm.education_experience)
                }
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        // 5cf3c4161bd77 新增
                        // 5cf3c448ad3db 编辑
                        if(this.editForm.avatar) {
                            if(typeof this.editForm.avatar === 'object') {
                                this.editForm.avatar = this.editForm.avatar[0].url
                            }
                        }
                        this.api.post(this.noResume?'/5cf3c4161bd77':'/5cf3c448ad3db', this.editForm).then(r =>{
                            this.loading = false
                            this.$message({
                                message: this.noResume?'新增成功':'编辑成功',
                                type: 'success'
                            })
                            this.edit_resume = false
                            this.getResume()
                        })
                    } else {
                        return false;
                    }
                });
            },

            // 取消提交简历
            resetResume() {
                if(this.noResume) {
                    this.$message('您还没有简历，请先创建简历');
                } else {
                    this.edit_resume = false
                    this.getResume()
                }
            },

            // 上传成功
            uploadSuccess(e) {
                if(e) {
                    this.uploadDialog = false
                    this.getResume()
                }
            },

            // 打开附件
            openAttach() {
                window.open(this.editForm.attach)
            }
        }
    }
</script>

<style lang="scss" scoped>
.web {
    padding-top: 20px;
    .catalogue.isFixed {
        position: fixed;
        width: 179px;
        top: 0;
    }
    .resume.isFixed {
        margin-left: 199px;
    }
    .catalogue {
        background: white;
        .catalogueTitle {
            height: 50px;
            line-height: 50px;
            color: #24272e;
            padding: 0 20px;
        }
        .catalogueBox {
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            transition: all .15s linear;
            color: #61687c;
            font-size: 14px;
            cursor: pointer;
        }
        .catalogueBox:hover {
            background-color: #f2f5f9;
        }
    }
    .resume {
        background: white;
        .resumeTitle {
            height: 52px;
            line-height: 52px;
            padding: 0 30px;
            font-size: 14px;
            border-bottom: 1px solid #f3f3f3;
            >div {
                font-weight: bold;
            }
        }
        .noData {
            padding-bottom: 30%;
        }
        .resumeEdit {
            padding: 0 30px;
            .boxWid {
                width: 100%;
            }
            .boxHei {
                height: 81px;
            }
            .box {
                position: relative;
                .delBox {
                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: 9;
                }
            }
        }
    }
}

.resumeBoxTitle {
    margin-top: 20px;
    padding-left: 5px;
    border-left: 3px solid #ff5b12;
    margin-bottom: 10px;
    font-size: 16px;
}

.enclosure {
    padding: 20px;
    background: #fff;
    .enclosureTitle {
        font-size: 14px;
        color: #414a60;
    }
    .enclosureBox {
        margin-top: 20px;
        font-size: 14px;
        .attach {
            cursor: pointer;
        }
        >div:nth-child(1) {
            max-width: 132px;
        }
        .enclosureDel {
            cursor: pointer;
        }
        .enclosureDel:hover {
            color: #ff5b12;
        }
    }
    .enclosureBtn {
        background: #ff5b12;
        color: white;
        font-size: 14px;
        text-align: center;
        margin-top: 20px;
        padding: 5px 0;
        cursor: pointer;
        transition: opacity .2s;
    }
    .enclosureBtn:hover {
        opacity: 0.9;
    }
}
.enclosureTip {
    color: white;
    background: #7aa8f3;
    color: #fff;
    height: 30px;
    line-height: 30px;
    padding: 0 5px;
    font-size: 12px;
}

.Privacy {
    margin-top: 16px;
    background: #fff;
    .PrivacyBox {
        padding: 20px;
        border-top: 1px solid #f3f3f3;
        font-size: 14px;
        .PrivacyBtn {
            color: #ff5b12;
        }
    }
    .PrivacyBox:first-child {
        border-top: none;
    }
}

.submitResume {
    width: 50%;
    margin: 0 auto;
    padding-bottom: 20px;
    .submitResumeBtn {
        text-align: center;
        padding: 10px 0;
        border-radius: 4px;
        cursor: pointer;
    }
    .submitResumeBtnNo {
        border: 1px solid #ff5b12;
        color: #ff5b12;
    }
    .submitResumeBtnYes {
        background: #ff5b12;
        border: 1px solid #ff5b12;
        color: white;
    }
}

.preview {
    padding: 15px 30px;
    .previewName {
        font-size: 24px;
        color: #24272e;
        padding-bottom: 10px;
    }
    .personalInfo {
        padding-top: 10px;
        font-size: 14px;
        >div {
            padding-top: 10px;
            i {
                margin-right: 5px;
            }
        }
        >div:first-child {
            padding-top: 0;
        }
        .certificate {
            padding-top: 20px;
            .certificateBox {
                padding-top: 10px;
                >span {
                    margin-right: 5px;
                }
            }
        }

        .previewEdu {
            .schoolName {
                >span:nth-child(1) {
                    font-size: 15px;
                    color: #414a60;
                }
                >span:nth-child(2) {
                    font-size: 12px;
                    margin-left: 30px;
                    color: #9fa3b0;
                }
            }
            .major {
                padding-top: 10px;
                color: #61687c;
                font-size: 15px;
                font-weight: bold;
                span {
                    font-weight: normal;
                }
            }
        }
    }
}
.editTips {
    color: red;
}

.notext {
    color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/job/resume.vue